import { render, staticRenderFns } from "./appInfo.vue?vue&type=template&id=8a851436&scoped=true&"
import script from "./appInfo.vue?vue&type=script&lang=js&"
export * from "./appInfo.vue?vue&type=script&lang=js&"
import style0 from "./appInfo.vue?vue&type=style&index=0&id=8a851436&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a851436",
  null
  
)

export default component.exports